// extracted by mini-css-extract-plugin
module.exports = {"tip_container":"tip_container___FE3RY","tip_icon_container":"tip_icon_container___1ii8W","tip_icon":"tip_icon___2dVlr","tip_label":"tip_label___og1UR"};